import React from 'react';
import {withRouter} from 'react-router-dom';


class AudioPlayer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            src: props.src,
            playActive: true
        };

        this.audio = new Audio();
        this.stop = this.stop.bind(this);
    }

    componentDidMount() {
        const {moduleURL = ''} = this.props;
        document.addEventListener('stop_audio', this.stop);
        this.audio.src = `${moduleURL}/media/${this.state.src}`;

        this.audio.addEventListener('play', () => {
            this.setState({playActive: true});
        });
        this.audio.addEventListener('pause', () => {
            this.setState({playActive: false});
        });
        this.audio.addEventListener('ended', () => {
            this.setState({playActive: false});
        });

        this.audio.play();
    }

    componentWillUnmount() {
        document.removeEventListener('stop_audio', this.stop);
        document.removeEventListener('play', this.stop);
        document.removeEventListener('pause', this.stop);
        document.removeEventListener('ended', this.stop);
    }

    play() {
        this.setState({playActive: true});
        this.audio.play();
    }

    pause() {
        this.setState({playActive: false});
        this.audio.pause();
    }

    stop() {
        this.setState({playActive: false});
        this.audio.pause();
        this.audio.currentTime = 0.0;
    }

    render() {
        const {answered = false} = this.props;
        return (
            <div>
                {!answered &&
                    <div>
                        <button className="node button-node assessment-play" onClick={this.play.bind(this)}
                                disabled={this.state.playActive === true}>
                        </button>
                        <button className="node button-node assessment-pause" onClick={this.pause.bind(this)}
                                disabled={this.state.playActive === false}>
                        </button>
                    </div>
                }
            </div>
        );
    }

}

export default withRouter(AudioPlayer);



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/audio-player.js